module.exports = __webpack_public_path__ + "67f1ec233826834cc50a2d5b9982bd70.svg";